import dateFilter from "@/filters/date-filter"
import { create } from "jss"
import preset from "jss-preset-default"

const jss = create(preset())
const sheet = jss.createStyleSheet({}, { link: true })

export default {
  data() {
    return {
      popoverContent: "",
      popoverVisible: false,
      popoverClass: "",
      popoverRef: "",
      popoverPlacement: "top"
    }
  },
  props: {
    customPopover: {
      type: String,
      default: null
    },
  },
  emits: ['row-click'],
  beforeUnmount() {
    sheet.detach()
  },
  methods: {
    resetPopover() {
      this.popoverVisible = false
      this.popoverContent = ""
    },
    handleRowClick(row, column, event) {
      this.$emit("row-click", row, column, event)
      if (column && !column.label) {
        this.resetPopover()
      } else {
        let content = this.getPopoverContent(row)
        if (content) {
          this.popoverContent = content
          this.popoverVisible = true
          this.createPopoverClass(event)
        }
      }
    },
    getPopoverContent(row) {
      let modifiedAt = row.dateModified ? row.dateModified : row.modifiedAt
      let datePrefix = modifiedAt
        ? (modifiedAt === row.dateCreated ? "Создано" : "Изменено")
        : (modifiedAt || row.dateCreated ? "Создано" : "")
      if (row.modifiedBy === "00000000-0000-0000-0000-000000000000") {
        datePrefix += datePrefix ? " системой" : "Создано системой"
      }
      let dateModified = modifiedAt ? dateFilter(modifiedAt, "YYYY-MM-DDTHH:mm:ss", "DD.MM.YYYY HH:mm") : ""
      let dateCreated = row.dateCreated ? dateFilter(row.dateCreated, "YYYY-MM-DDTHH:mm:ss", "DD.MM.YYYY HH:mm") : ""
      let date = dateModified || dateCreated
      let author = row.modifiedByName
      let fromMobile = row.fromMobile ? "Создано с мп" : ""
      let content = [datePrefix, date, author, fromMobile].join("\n")
      return content.trim()
    },
    createPopoverClass(event) {
      this.$nextTick(() => {
        const name = "popoverClass"
        const options = { className: "popoverClass" }
        const popoverEl = this.$refs.popover?.$el
        const width = popoverEl?.offsetWidth || 200
        const height = popoverEl?.offsetHeight || 0
        const margin = 10

        let left = event.clientX - width - margin
        if (left < 0 && event.clientX + width + margin <= window.innerWidth) {
          left = event.clientX + margin
        } else if (event.clientX + width + margin > window.innerWidth) {
          left = Math.max(window.innerWidth - width - margin, 0)
        }

        let top = event.clientY - height - margin
        this.popoverPlacement = "top"
        if (top < 0 && event.clientY + height + margin <= window.innerHeight) {
          top = event.clientY + margin
          this.popoverPlacement = "bottom"
        } else if (event.clientY + height + margin > window.innerHeight) {
          top = Math.max(window.innerHeight - height - margin, 0)
          this.popoverPlacement = "top"
        }

        const style = {
          padding: "0px",
          position: "fixed",
          left: `${left}px !important`,
          top: `${top}px !important`,
          whiteSpace: "pre-line",
        }
        sheet.deleteRule(name)
        sheet.addRule(name, style, options)
        sheet.detach()
        sheet.attach()
        this.popoverClass = sheet.getRule(name).selectorText.slice(1)
      })
    },
  },
}
